import {
  Box,
  Button,
  Card,
  Divider,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { BIBlue, BIGrey } from "../../assets/helpers";
import SouthIcon from "@mui/icons-material/South";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import mapMarkerBlue from "../../assets/images/marker_blue.png";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SearchMap from "../sites/SearchMap";

const SitesTutorial = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = 240;

  const circleOuterStyle = {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#ffde89",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px"
  };

  const circleInnerStyle = {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "#FFBC0A",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };

  const {
    TEXT_MY_SITES = English?.SitesTutorial?.TEXT_MY_SITES,
    TEXT_FOLLOWING = English?.SitesTutorial?.TEXT_FOLLOWING,
    TEXT_UNNAMED = English?.SitesTutorial?.TEXT_UNNAMED,
    TEXT_ACTIVE_SITES = English?.SitesTutorial?.TEXT_ACTIVE_SITES,
    TEXT_MAP = English?.SitesTutorial?.TEXT_MAP,
    TEXT_PAGE_ONE_SUBHEADER = English?.SitesTutorial?.TEXT_PAGE_ONE_SUBHEADER,
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN = English?.SitesTutorial?.TEXT_TUTORIAL_MODAL_ANYWHERE_BTN,
    TEXT_PAGE_TWO_SUBHEADER_ONE = English?.SitesTutorial?.TEXT_PAGE_TWO_SUBHEADER_ONE,
    TEXT_PAGE_TWO_SUBHEADER_TWO = English?.SitesTutorial?.TEXT_PAGE_TWO_SUBHEADER_TWO,
    TEXT_PAGE_TWO_SUBHEADER_THREE = English?.SitesTutorial?.TEXT_PAGE_TWO_SUBHEADER_THREE,
    TEXT_PAGE_THREE_SUBHEADER_ONE = English?.SitesTutorial?.TEXT_PAGE_THREE_SUBHEADER_ONE,
    TEXT_PAGE_THREE_SUBHEADER_TWO = English?.SitesTutorial?.TEXT_PAGE_THREE_SUBHEADER_TWO,
    TEXT_SEARCH_MAP = English?.SitesTutorial?.TEXT_SEARCH_MAP,
    TEXT_PAGE_FOUR_SUBHEADER_ONE = English?.SitesTutorial?.TEXT_PAGE_FOUR_SUBHEADER_ONE,
    TEXT_PAGE_FOUR_SUBHEADER_TWO = English?.SitesTutorial?.TEXT_PAGE_FOUR_SUBHEADER_TWO,
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_ONE = English?.SitesTutorial
      ?.TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_ONE,
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_TWO = English?.SitesTutorial
      ?.TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_TWO,
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_THREE = English?.SitesTutorial
      ?.TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_THREE,
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FOUR = English?.SitesTutorial
      ?.TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FOUR,
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FIVE = English?.SitesTutorial
      ?.TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FIVE,
    BUTTON_FOLLOW = English?.SitesTutorial?.BUTTON_FOLLOW,
    TEXT_ADD_TO_PROFILE = English?.SitesTutorial?.TEXT_ADD_TO_PROFILE
  } = multiLanguageData?.SitesTutorial || {};

  const siteButtons = [
    { label: TEXT_MY_SITES, value: "My Sites" },
    { label: TEXT_FOLLOWING, value: "Following" },
    { label: TEXT_UNNAMED, value: "Unnamed" },
    { label: TEXT_ACTIVE_SITES, value: "Active Sites" }
  ];

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box className="main-content-Box" sx={{ backgroundColor: "transparent" }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_MAP}</Typography>
                  <Typography variant="subtitle1">{TEXT_PAGE_ONE_SUBHEADER}</Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}>
                      {" "}
                      {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                    </span>
                  </Typography>
                </Stack>
              </Box>
            )}
            {props.tutorialIndex === 2 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="subtitle1">
                    {TEXT_PAGE_TWO_SUBHEADER_ONE}
                    <br />
                    {TEXT_PAGE_TWO_SUBHEADER_TWO}
                    <br />
                    {TEXT_PAGE_TWO_SUBHEADER_THREE}
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}>
                      {" "}
                      {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                    </span>
                  </Typography>
                  <Stack sx={{ justifyContent: "center", marginTop: "20px" }} direction="row" spacing={10}>
                    <Stack>
                      <SouthIcon style={{ fontSize: "40px" }} />
                      <Paper style={circleOuterStyle}>
                        <Paper style={circleInnerStyle}>
                          <Typography variant="h4" style={{ color: "white", fontSize: "18px" }}>
                            4
                          </Typography>
                        </Paper>
                      </Paper>
                    </Stack>
                    <Stack>
                      <SouthEastIcon style={{ fontSize: "40px" }} />
                      <Typography>
                        <img
                          src={mapMarkerBlue}
                          alt="map"
                          style={{ width: "25px", marginLeft: "40px" }}
                        />
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            )}

            {props.tutorialIndex === 3 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  height: "100%"
                }}>
                <Stack direction={"row"} sx={{ mr: 7,  mb: 5,  alignItems: "center" }}  >
                  <Stack sx={{ alignItems: "center" }}>
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      {TEXT_PAGE_THREE_SUBHEADER_ONE}
                    </Typography>
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      {TEXT_PAGE_THREE_SUBHEADER_TWO}
                    </Typography>
                    <Typography variant="body1">
                      <span style={{ color: BIBlue }}>
                        {" "}
                        {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                      </span>
                    </Typography>
                  </Stack>
                  <SouthEastIcon style={{ fontSize: "40px", color: "white" }} />
                </Stack>
                <Stack className="mapicon-group">
                  <IconButton className="mapicon-btn plusicon-btn" color="primary">
                    <AddIcon sx={{ fontSize: "28px" }} />
                  </IconButton>
                </Stack>
              </Box>
            )}

            {props.tutorialIndex === 4 && (
              <Box className={"main-content-Box"}>
                <Card
                  className="main-content-card"
                  sx={{
                    position: "absolute",
                    mt: 0,
                    p: 0.5,
                    pl: 0,
                    pr: 0,
                    width: isSmallScreen ? "100%" : isMediumScreen ? "69%" : "400px",
                    backgroundColor: "transparent !important",
                    border: "none",
                    pt: "0px !important"
                  }}>
                  <Box sx={{ height: "110px", backgroundColor: "white" }}>
                    <Box sx={{ justifyContent: "flex-end",  display: "flex", p: 1, mt: 0.5 }}>
                      <Card
                        className={"searchText-Box-Container"}
                        sx={{ borderRadius: "25px", border: "1px solid #e3e3e3" }}>
                        <SearchMap from={"map"} searchTerm={""} placeholder={TEXT_SEARCH_MAP} />
                      </Card>
                      <IconButton disabled>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                    <Divider />
                    <Box sx={{ width: isMediumScreen ? "100%" : "400px" }}>
                      <Stack
                        direction="row"
                        spacing={0.5}
                        sx={{ p: 0.5 }}
                        divider={<Divider orientation="vertical" flexItem />}>
                        {siteButtons.map((btn) => (
                          <Button
                            size="small"
                            fullWidth
                            sx={{ fontWeight: "normal", p: 1, fontSize: 12 }}
                            key={btn.value}
                            color={"inherit"}
                            variant={"text"}>
                            {btn.label}
                          </Button>
                        ))}
                      </Stack>
                      <Divider />
                    </Box>
                  </Box>
                </Card>

                <Stack sx={{ ml: 3,  mt: 13 }} >
                  <Stack direction="row" spacing={8}>
                    <SouthIcon style={{ fontSize: "40px", color: "white" }} />
                    <SouthIcon style={{ fontSize: "40px", color: "white" }} />
                  </Stack>

                  <Stack style={{ color: "white", textAlign: "left" }}>
                    <Typography variant="subtitle1" sx={{ ml: 10 }}>
                      {TEXT_PAGE_FOUR_SUBHEADER_ONE}
                    </Typography>
                    <Typography variant="subtitle1">{TEXT_PAGE_FOUR_SUBHEADER_TWO}</Typography>
                    <Typography variant="subtitle1" sx={{ ml: 10 }}>
                      <span style={{ color: BIBlue }}>
                        {" "}
                        {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                      </span>
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            )}

            {props.tutorialIndex === 5 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%"
                }}>
                <Stack style={{ color: "white", textAlign: "center" }}>
                  <Typography variant="subtitle1">
                    <div>{TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_ONE}</div>
                    <div>{TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_TWO}</div>
                    <div style={{ marginTop: "10px" }}>
                      {TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_THREE}
                    </div>
                    <div>{TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FOUR}</div>
                  </Typography>
                  <div style={{ marginTop: "10px" }}>{TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FIVE}</div>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}>
                      {" "}
                      {`(${TEXT_TUTORIAL_MODAL_ANYWHERE_BTN})`}
                    </span>
                  </Typography>
                  <Typography>
                    <SouthIcon style={{ fontSize: "40px" }} />
                  </Typography>
                  <Stack sx={{ alignItems: "center" }}>
                    <Card sx={{ width: "300px", p: 2 }}>
                      <Stack sx={{ pb: 1,  alignItems: "flex-start" }} >
                        <Typography variant="body1">BMO Center</Typography>
                        <Typography variant="body2" style={{ color: BIGrey }}>
                          20 RoundUp Way SE
                        </Typography>
                      </Stack>
                      <Stack direction={"row"} sx={{ gap: 1,  justifyContent: "flex-start"  }} >
                        <Button variant="contained">{BUTTON_FOLLOW}</Button>
                        <Button variant="text">{TEXT_ADD_TO_PROFILE}</Button>
                      </Stack>
                    </Card>
                  </Stack>
                </Stack>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SitesTutorial;

